import { apiClient } from './client';

export interface Note {
  id: number;
  patient_id: number;
  author_user_id: number;
  author_name?: string;
  content: string;
  visibility: string;
  note_type: string;
  created_at: string;
}

interface NoteListResponse {
  notes: Note[];
  total: number;
}

export async function getNotes(patientId: number, noteType?: string, limit?: number): Promise<Note[]> {
  const params: Record<string, unknown> = {};
  if (noteType) params.note_type = noteType;
  if (limit) params.limit = limit;
  const response = await apiClient.get<NoteListResponse>(`/patients/${patientId}/notes`, { params });
  return response.data.notes;
}

export async function createNote(
  patientId: number,
  content: string,
  visibility: string,
  noteType: string,
): Promise<Note> {
  const response = await apiClient.post<Note>(`/patients/${patientId}/notes`, {
    content,
    visibility,
    note_type: noteType,
  });
  return response.data;
}
